import { render, staticRenderFns } from "./CatalogFilter.vue?vue&type=template&id=b69a2148&"
import script from "./CatalogFilter.vue?vue&type=script&lang=js&"
export * from "./CatalogFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports